import { MenuAvailability } from 'types/menu-availability';
import { MenuAvailabilityRequest } from 'types/menu.type';

const normalizeTimeForSelect = (time: string | undefined, fallback: string) => {
  if (!time) {
    return fallback;
  }

  const match = /^(\d{2}):(\d{2})/.exec(time);
  if (!match) {
    return fallback;
  }

  return `${match[1]}:${match[2]}`;
};

export const mapMenuHoursToMenuAvailability = (
  openHours: MenuAvailabilityRequest[],
): MenuAvailability => {
  const menuAvailability = {
    Monday: {
      open: false,
      startTime: '09:00',
      endTime: '18:00',
      dayIndex: 'MON',
    },
    Tuesday: {
      open: false,
      startTime: '09:00',
      endTime: '18:00',
      dayIndex: 'TUE',
    },
    Wednesday: {
      open: false,
      startTime: '09:00',
      endTime: '18:00',
      dayIndex: 'WED',
    },
    Thursday: {
      open: false,
      startTime: '09:00',
      endTime: '18:00',
      dayIndex: 'THU',
    },
    Friday: {
      open: false,
      startTime: '09:00',
      endTime: '18:00',
      dayIndex: 'FRI',
    },
    Saturday: {
      open: false,
      startTime: '09:00',
      endTime: '18:00',
      dayIndex: 'SAT',
    },
    Sunday: {
      open: false,
      startTime: '09:00',
      endTime: '18:00',
      dayIndex: 'SUN',
    },
  };
  openHours.forEach((x) => {
    Object.values(menuAvailability).forEach((e) => {
      if (e.dayIndex === x.day_index) {
        e.open = true;
        e.startTime = normalizeTimeForSelect(x.start_time, '09:00');
        e.endTime = normalizeTimeForSelect(x.end_time, '18:00');
      }
    });
  });

  return menuAvailability;
};
